var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._l((_vm.metadataView),function(m){return _c('v-row',{key:m.name},[_c('v-col',[_vm._v(_vm._s(m.name))]),_c('v-col',[_vm._v(_vm._s(m.value))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }